<template>
  <SysDialog
    v-model="MODAL_ATIVO_COMPUTED"
    largura="450"
    ocultar_botao_fechar
    content-class="bra-8"
    titulo="Crie uma Justificativa"
    ocultar-acoes
  >
    <v-form ref="formRef" lazy-validation>
      <v-row>
        <v-col cols="12">
          <div style="color: #4B4B53;" class="d-flex justify-space-between font-14 mb-2 font-weight-regular">
            Selecione uma Categoria
          </div>

          <v-select
            v-model="form.categoria"
            :rules="[rules.required]"
            :items="categorias"
            item-value="id"
            item-text="id"
            label="Escolha uma categoria"
            append-icon="$CaretDown"
            outlined
          />
        </v-col>

        <v-col class="mt-n7" cols="12">
          <div style="color: #4B4B53;" class="d-flex justify-space-between font-14 mb-2 font-weight-regular">
            Nome da Justificativa
          </div>

          <v-textarea
            v-model="form.justificativa"
            :rules="[rules.required]"
            rows="1"
            auto-grow
            outlined
            hide-details="auto"
            placeholder="Insira aqui o nome da justificativa..."
          />
        </v-col>
      </v-row>

      <div class="d-flex justify-end px-1 mt-4">
        <v-btn
          color="#013254"
          class="vbtn-class bra-8 w-20-porcento"
          height="35"
          outlined
          @click="voltar"
        >
          <span class="font-12">
            Cancelar
          </span>
        </v-btn>

        <v-btn
          color="#013254"
          class="white--text text-none bra-8 w-40-porcento"
          height="35"
          @click="salvar"
        >
          <span class="font-12">
            Salvar Justificativa
          </span>
        </v-btn>
      </div>
    </v-form>
  </SysDialog>
</template>

<script>
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import api from "@/api/api";
import moment from "moment/moment";

export default {
  name: "DialogCriarJustificativa",
  components: { SysDialog },
  props: {
    value: { type: Boolean, required: true },
    categorias: { type: Array, required: true }
  },
  data() {
    return {
      isValid: true,
      form: {
        categoria: null,
        justificativa: null
      },
      rules: {
        required: (v) => !!(v && String(v).trim()) || "Campo Obrigatório",
      }
    };
  },
  computed: {
    moment() {
      return moment
    },
    MODAL_ATIVO_COMPUTED: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    voltar() {
      this.MODAL_ATIVO_COMPUTED = false;
      this.resetarFormulario();
    },
    async salvar() {
      const ok = await this.$refs.formRef.validate();
      if (!ok) return;

      const body = {
        categoria: this.form.categoria,
        justificativa: this.form.justificativa
      }

      api.post('drp-grupo/cadastrar-tipos-justificativas', body)
      .then((response) => {
        alert(response.data.mensagem);

        this.resetarFormulario();
        this.$emit("upload:concluido");
      }).catch((error) => {
        alert(error);
      });

      this.MODAL_ATIVO_COMPUTED = false;
    },
    resetarFormulario() {
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.resetValidation();

        this.form = {
          categoria: null,
          justificativa: null
        };
      });
    }
  }
};
</script>

<style scoped>
.vbtn-class {
  text-transform: none;
  border: 1px solid #DFDFE0;
  padding: 10px 25px 10px 20px;
  margin-top: 1px;
  margin-right: 15px;
  font-weight: 500;
}
</style>
